import Modal from 'react-modal';
import { FiAlertTriangle, FiX } from 'react-icons/fi';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        borderRadius: '16px',
        padding: 0,
        border: 'none',
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        maxWidth: '92vw',
    },
    overlay: {
        background: 'rgba(15, 23, 42, 0.55)',
        backdropFilter: 'blur(2px)',
        zIndex: 9999,
    },
};

Modal.setAppElement(document.getElementById('root'));

export default function DeleteConfirm({
    title,
    description = 'Ky veprim nuk mund të kthehet pas.',
    cancelLabel = 'Anulo',
    confirmLabel = 'Fshi',
    isOpen,
    closeModal,
    handleConfirm,
}) {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel={title || 'Konfirmo veprimin'}
        >
            <div className="bg-white w-[440px] max-w-full">
                {/* Header */}
                <div className="flex items-start justify-between px-6 pt-5 pb-4 border-b border-gray-100">
                    <div className="flex items-center gap-3">
                        <span className="inline-flex items-center justify-center w-10 h-10 rounded-xl bg-red-50 text-red-600 ring-1 ring-inset ring-red-100">
                            <FiAlertTriangle size={20} />
                        </span>
                        <div>
                            <div className="text-base font-semibold text-gray-900">
                                {title || 'Konfirmo veprimin'}
                            </div>
                            <div className="text-xs text-gray-500">
                                A jeni i sigurt që dëshironi të vazhdoni?
                            </div>
                        </div>
                    </div>
                    <button
                        type="button"
                        onClick={closeModal}
                        className="text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg p-1.5 transition"
                        aria-label="Mbyll"
                    >
                        <FiX size={18} />
                    </button>
                </div>

                {/* Body */}
                <div className="px-6 py-5">
                    <p className="text-sm text-gray-600 leading-relaxed">{description}</p>
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-2 px-6 py-4 border-t border-gray-100 bg-gray-50/60">
                    <button
                        type="button"
                        onClick={closeModal}
                        className="inline-flex items-center gap-2 rounded-xl border border-gray-300 bg-white hover:bg-gray-50 px-4 py-2 text-sm font-semibold text-gray-700 shadow-sm transition"
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        className="inline-flex items-center gap-2 rounded-xl bg-secondary hover:bg-red-700 active:scale-[0.98] px-4 py-2 text-sm font-semibold text-white shadow-sm transition"
                    >
                        {confirmLabel}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
